import Vue from 'vue';
import store from './store/store';
import Router from 'vue-router';

//PAGES
const Login = () => import('./views/Login');
const UserRegistration = () => import('./views/UserRegistration');
const UserRegistered = () => import('./views/UserRegistered');
const AccountConfirmation = () => import('./views/AccountConfirmation');
const ForgotPassword = () => import('./views/ForgotPassword');
const ResetPassword = () => import('./views/ResetPassword');
const FileNow = () => import('./views/FileNow');
const Search = () => import('./views/PublicSearch');

//FORMS
const FilerInformation = () => import('./views/filing/FilerInformation');
const UserProfileUpdate = () => import('./views/filing/UserProfileUpdate');
const Directorships = () => import('./views/filing/Directorships');
const IncomeSources = () => import('./views/filing/IncomeSources');
const Gifts = () => import('./views/filing/Gifts');
const Creditors = () => import('./views/filing/Creditors');
const BusinessInterest = () => import('./views/filing/BusinessInterest');
const BusinessInterestsTransferred = () => import('./views/filing/BusinessInterestsTransferred');
const RealEstate = () => import('./views/filing/RealEstate');
const Family = () => import('./views/filing/Family');
const ReviewStatements = () => import('./views/filing/ReviewStatements');
const SubmitStatements = () => import('./views/filing/SubmitStatements');
const StatementsSubmitted = () => import('./views/filing/StatementsSubmitted');

//Other
const EditUserProfile = () => import('./views/EditUserProfile');
const MaintenanceMode = () => import('./views/MaintenanceMode');

/**
* ADMIN VIEWS
*/
const FilerAdministration = () => import('./views/admin/FilerAdministration');
const ScreensAndMenus = () => import('./views/admin/ScreensAndMenus');
const ImportFilers = () => import('./views/admin/ImportFilers');
const Reports = () => import('./views/admin/Reports');
const FilingData = () => import('./views/admin/FilingData');

/**
 * Layouts
 */
const Default = () => import('./layouts/Default');
const User = () => import('./layouts/User');

/**
 * Layouts Paths
 */
const Filing = () => import('./layouts/paths/Filing');
const FourOFour = () => import('./views/FourOFour');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'default',
      path: '/',
      component: Default,
      children: [
        {
          path: '/',
          name: 'login',
          component: Login,
        },
        {
          path: 'user-registration',
          name: 'user-registration',
          component: UserRegistration,
        },
        {
          path: 'user-registered',
          name: 'user-registered',
          component: UserRegistered,
          props: true,
          meta: {
            isCentered: true,
          },
        },
        {
          path: 'account-confirmation',
          name: 'account-confirmation',
          component: AccountConfirmation,
          meta: {
            isCentered: true,
          },
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: ForgotPassword,
          meta: {
            isCentered: true,
          },
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: ResetPassword,
          meta: {
            isCentered: true,
          },
        },
        {
          path: '404',
          name: 'four-o-four',
          component: FourOFour,
          meta: {
            isCentered: true,
          },
        },
        {
          path: 'maintenance',
          name: 'maintenance-mode',
          component: MaintenanceMode,
          meta: {
            isCentered: true,
          },
        },
        {
          path: 'search',
          name: 'search',
          component: Search,
        },
      ],
    },
    {
      path: '/u',
      name: 'user',
      component: User,
      children: [
        {
          path: 'file-now',
          name: 'file-now',
          component: FileNow,
          meta: {
            label: 'File Now',
          },
        },
        {
          path: 'filing',
          name: 'filing',
          component: Filing,
          children: [
            {
              path: 'filer-information',
              name: 'filer-information',
              component: FilerInformation,
              meta: {
                label: 'Filer Information',
                isFilingScreen: true,
              },
            },
            {
              path: 'user-profile-update',
              name: 'user-profile-update',
              component: UserProfileUpdate,
              meta: {},
            },
            {
              path: 'directorships',
              name: 'directorships',
              component: Directorships,
              meta: {
                label: 'Directorships',
                isFilingScreen: true,
              },
            },
            {
              path: 'income-sources',
              name: 'income-sources',
              component: IncomeSources,
              meta: {
                label: 'Income Sources',
                isFilingScreen: true,
              },
            },
            {
              path: 'gifts',
              name: 'gifts',
              component: Gifts,
              meta: {
                label: 'Gifts',
                isFilingScreen: true,
              },
            },
            {
              path: 'creditors',
              name: 'creditors',
              component: Creditors,
              meta: {
                label: 'Creditors',
                isFilingScreen: true,
              },
            },
            {
              path: 'business-interest',
              name: 'business-interest',
              component: BusinessInterest,
              meta: {
                label: 'Business Interest',
                isFilingScreen: true,
              },
            },
            {
              path: 'business-interest-transferred',
              name: 'business-interest-transferred',
              component: BusinessInterestsTransferred,
              meta: {
                label: 'Business Interest Transferred',
                isFilingScreen: true,
              },
            },
            {
              path: 'real-estate',
              name: 'real-estate',
              component: RealEstate,
              meta: {
                label: 'Real Estate',
                isFilingScreen: true,
              },
            },
            {
              path: 'family',
              name: 'family',
              component: Family,
              meta: {
                label: 'Family',
                isFilingScreen: true,
              },
            },
            {
              path: 'review-statements',
              name: 'review-statements',
              meta: {
                label: 'Review Statements',
              },
              component: ReviewStatements,
            },
            {
              path: 'submit-statements',
              name: 'submit-statements',
              meta: {
                label: 'Submit Statements',
              },
              component: SubmitStatements,
            },
            {
              path: 'statements-submitted',
              name: 'statements-submitted',
              meta: {
                label: 'Statements Submitted',
              },
              component: StatementsSubmitted,
            },
          ],
        },
        {
          path: 'edit-user-profile',
          name: 'edit-user-profile',
          meta: {
            label: 'Edit Profile',
          },
          component: EditUserProfile,
        },
      ],
    },
    {
      path: '/a',
      name: 'admin',
      component: User,
      children: [
        {
          path: 'filer-administration',
          name: 'filer-administration',
          component: FilerAdministration,
          meta: {
            label: 'Filer Administration',
          },
        },
        {
          path: 'import-filers',
          name: 'import-filers',
          component: ImportFilers,
          meta: {
            label: 'Import Filers',
          },
        },
        {
          path: 'screens-and-menus',
          name: 'screens-and-menus',
          component: ScreensAndMenus,
          meta: {
            label: 'Screens & Menus',
          },
        },
        {
          path: 'reports',
          name: 'reports',
          component: Reports,
          meta: {
            label: 'Reports',
          },
        },
        {
          path: 'filing-data/:userId/:filingId',
          name: 'filing-data',
          component: FilingData,
          meta: {
            label: 'Filing Data',
          },
        },
      ],
    },
  ],
});

// router.afterEach(() => {
//   setTimeout(function () {
//     store.commit('loading', false);
//   }, 500);
// });

router.beforeEach(async (to, from, next) => {

  store.commit('loading', true);

  //if route exists
  if (to.matched.length > 0) {

    let loggedInPaths = [ 'user', 'admin' ];
    let rootPath = to.matched[0].name;

    //Is user logged in protected path?
    if (!loggedInPaths.includes(rootPath)) {
      return next();
    }

    //Is user logged in
    if (!store.getters['login/isLoggedIn'] && to.name !== 'login') {
      return next({ name: 'login' });
    }

    //Get user profile
    if (Object.keys(store.state.user.profile).length === 0) {
      await store.dispatch('user/fetchUserProfile');
    }

    //Get filing if in filing screen
    let hasCurrentFilingId = await store.dispatch('filing/checkCurrentFilingId');
    if (hasCurrentFilingId) {
      await store.dispatch('filing/fetchFiling');
    }

    //Get user access
    let hasScreenAccess = store.getters['user/hasScreenAccess'](to.name);

    //Does user have access to this screen?
    if (!hasScreenAccess && to.name !== 'login') {
      return next({ name: 'login' });
    }

    //If in maintenance mode go to specific screens
    let isMaintenanceMode = await store.dispatch('login/maintenanceMode');

    if (isMaintenanceMode) {
      if (to.name !== 'maintenance-mode' && to.name !== 'import-filers' && to.name !== 'screens-and-menus') {
        if (store.state.user.profile.sysAdmin === 'Y') {
          store.commit('loading', false);
          return next({ name: 'import-filers' });
        }
        store.commit('loading', false);
        return next({ name: 'maintenance-mode' });
      }
    }

    //Exception to default routing: user-profile-update can only be accessed from filer-information screen
    if (to.name === 'user-profile-update' && from.name !== 'filer-information') {
      return next({ name: 'filer-information' });
    }

    return next();

  }

  return next({ name: 'four-o-four' });

});

export default router;
